import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { DropDownList } from '@progress/kendo-react-dropdowns';
import Slider from "react-slick";
import './MemberDiscounts.scss';
import { ROOT_API_URL } from "../../../../../api-config";
import { auth } from '../../../../../services';
import { history } from '../../../../../helpers/history';

import EventsFilter from '../Events/EventFilters';

class MemberDiscountsHome extends Component {
  constructor(props) {
    super(props);

    this.state = {
        listOfMemberDiscounts: [],
        loading: true,
    }
  }

  componentDidMount() {
    this.getMemberDiscounts();
  }

  getMemberDiscounts(){
    axios.get(`${ROOT_API_URL}/MembershipDiscounts/GetMembershipDiscounts`, { headers: auth.authHeader() })
      .then((response) =>{
        this.setState({
          listOfMemberDiscounts: response.data
        });
        const copyArray = this.state.listOfMemberDiscounts;
        for(let i = 0; i < copyArray.length; i++){
          if(!copyArray[i].externalURL.includes('https://') && !copyArray[i].externalURL.includes('http://') ){
            var x = copyArray[i].externalURL;
            copyArray[i].externalURL = "https://" + x;
          }
        }
        this.setState({
            listOfMemberDiscounts: copyArray,
            loading: false
        })
      })
      .catch((response) => {
        //history.push('/oops');
        console.log(response);
      });
  }

  renderDiscountList = () => {
    return this.state.listOfMemberDiscounts.map((discount) => {
      return(
        <div className="discountCard row" key={discount.membershipDiscountId}>
          <div className="col-lg-4 d-flex flex-column justify-content-center align-items-center p-0">
            <div className="header">
              {
                discount.logoImage ?
                  <img src={discount.logoImage}  alt={discount.companyName}/> :
                  <img src="/images/TSCRABackgroundLOGO.png" className="defaultImgHeight" alt="Discount Placeholder Image" />
              }
            </div>
          </div>
          <div className="col-lg-5 d-flex flex-column  justify-content-start py-0 px-3 pt-3 ">
            <h2 className="productTitle">{discount.companyName}</h2>
            <h4 className="productDescription">{discount.description}</h4>
          </div>
          <div className="col-lg-3 d-flex flex-column align-items-center justify-content-start p-0 pt-3" >
            <a href={discount.externalURL} target="_blank"><button className="pdfDownloadBtn">Visit Site</button></a>
          </div>
        </div>
      )}
    )
  }

  render() {
    return (
      <div className="eventsPage">
        <div className="container">
          <div className="archiveTitle">Member Discounts</div>
          {
            (this.state.loading) ? "Loading.." :
              this.state.listOfMemberDiscounts.length != 0 ? this.renderDiscountList() : "There are currently no Member Discounts"
          }

        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    common: state.common
  }
}

export default connect(null, {})(MemberDiscountsHome);
